import type { IconData } from '@stacksjs/iconify-core'

export const hu1x1: IconData = {
  "body": "<g fill-rule=\"evenodd\"><path fill=\"#fff\" d=\"M512 512H0V0h512z\"/><path fill=\"#388d00\" d=\"M512 512H0V341.3h512z\"/><path fill=\"#d43516\" d=\"M512 170.8H0V.1h512z\"/></g>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default hu1x1
